import {
  Link as ReactDomLink,
  LinkProps as ReactDomLinkProps,
  To,
} from 'react-router-dom';

import { objectToQueryString } from 'src/utils/query-string';

export type LinkProps = ReactDomLinkProps & {
  queryParams?: Record<string | number, any>;
};

export const Link = (props: LinkProps) => {
  const { queryParams, to, ...restProps } = props || {};

  const isExternal =
    typeof to === 'string' &&
    (to.startsWith('http://') || to.startsWith('https://'));
  if (isExternal) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" {...restProps} />
    );
  }

  const queryString = queryParams ? objectToQueryString(queryParams) : null;
  const linkTo: To = typeof to === 'string' ? { pathname: to } : to;
  const linkSearch = typeof to === 'string' ? null : to.search;
  const mergedLinkTo = {
    ...linkTo,
    search: [linkSearch, queryString].filter(Boolean).join('&'),
  };

  return <ReactDomLink to={mergedLinkTo} {...restProps} />;
};
